import * as React from "react";
import Footer from "../footer";
import { Open_Sans } from "next/font/google";
import Header from "../header";
import Link from "next/link";
import { useRouter } from "next/router";
const roboto = Open_Sans({
  weight: ["300", "400", "500", "700"],
  style: ["normal"],
  subsets: ["latin"],
  display: "swap",
  variable: "--font-roboto",
});

const Layout = ({ children }) => {
  const { pathname } = useRouter();
  return (
    <div
      className={`min-h-screen flex flex-col justify-between bg-white ${roboto.variable} font-roboto`}
    >
      <Header />
      {pathname !== "/data-hub" && (
        <Link
          href="/data-hub"
          className="w-full bg-blue hover:text-lightBlue py-2 text-white md:text-sm text-xs text-center px-8 md:px-8 flex items-center justify-center transition-all duration-200 ease"
        >
          Visit PCI's Data Hub for interactive dashboards presenting key
          insights from our research studies.
        </Link>
      )}
      <main className="flex-grow w-full">{children}</main>
      <Footer />
    </div>
  );
};
export default Layout;
